/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_ContactInputs */

const en_landing_nav_contact = /** @type {(inputs: Landing_Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const pl_landing_nav_contact = /** @type {(inputs: Landing_Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Landing_Nav_ContactInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_nav_contact = /** @type {((inputs?: Landing_Nav_ContactInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_ContactInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_nav_contact(inputs)
	return en_landing_nav_contact(inputs)
});